﻿const trigger = '.toggle-text__trigger';


function toggleText(e) {
	e.preventDefault();
	const $this = $(this);
	const $parent = $this.closest('.toggle-text');

	const $divs = $parent.children('div');
	const $full = $($divs[0]);
	const $short = $($divs[1]);

	if ($this.hasClass('active')) {
		$full.addClass('hidden');
		$short.removeClass('hidden');
	} else {
		$full.removeClass('hidden');
		$short.addClass('hidden');
	}

	/*
	// timeout is for animation
	setTimeout(() => {
		if (wrap.hasClass('active')) {
			wrap.css({ maxHeight: wrapShortHeight });
			wrap.removeClass('active');
			$this.removeClass('active');

			setTimeout(() => {
				wrap
					.html('')
					.html(holderText);
			}, 400)
		} else {

			wrap
				.html('')
				.wrapInner(`<div class="text-toggle__inner">${holderText}</div>`);


			wrap.css({ maxHeight: wrap.find('.text-toggle__inner').height() });
			wrap.addClass('active');
			$this.addClass('active');
		}


		wrap.attr('data-holder', currentText);
		$this.attr('data-text', currentButtonText);
	}, 100);
	*/
}

$(document).on('click', trigger, toggleText);